// extracted by mini-css-extract-plugin
export default {"primary":"ExpertCard_primary__f5RW7","avatar":"ExpertCard_avatar__dsSb3"};